import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BreadcrumbModule } from '@commons/breadcrumb/breadcrumb.module';
import { FooterModule } from '@commons/footer/footer.module';
import { HeaderModule } from '@commons/header/header.module';
import { ResizeObserverDirective } from '@commons/resize-observer/resize-observer.directive';
import { SvgIconModule } from '@commons/svg-icon/svg-icon.module';
import { TrackerModule } from '@commons/tracker/tracker.module';
import { JobGuard } from '@core/guards/job.guard';
import { AdvertisingModule } from '@domains/advertising/advertising.module';
import { JobModule } from '@domains/job/job.module';
import { LayoutComponent } from '@features/jobs-unlogged/layout/layout.component';
import { ViewComponent } from '@features/jobs-unlogged/view/view.component';
import { JobUnloggedRoutingModule } from '@routing/job-unlogged/job-unlogged-routing.module';
import { CompanyStoreModule } from '@store/company/company.store.module';
import { JobsStoreModule } from '@store/job/jobs.store.module';
import { HeadDescriptionModule, HeadTitleModule } from '@wizbii/seo-lib';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

@NgModule({
  imports: [
    CommonModule,
    AdvertisingModule,
    JobUnloggedRoutingModule,
    JobModule,
    HeaderModule,
    PerfectScrollbarModule,
    FooterModule,
    CompanyStoreModule,
    JobsStoreModule,
    HeadTitleModule,
    HeadDescriptionModule,
    TrackerModule,
    SvgIconModule,
    BreadcrumbModule,
  ],
  declarations: [LayoutComponent, ViewComponent, ResizeObserverDirective],
  providers: [JobGuard],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class JobUnloggedModule {}
